export default {"src":"/_next/static/media/play_arrow.deb990fb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};